import { Controller } from 'stimulus'

# Delegate to App.Views.OrderFormView
export default class extends Controller
  connect: ->
    new App.Views.OrderFormView
      el: @element
